export default __webpack_public_path__ + "static/media/referral_1.5fc2db67.svg";